import { sessionStorageUtil } from "./storageUtils";
import Notice from 'Components/Notice';
import platform from "Pub/js/platform";
import { getStore, setStore } from './storageUtils';
import Browser from './browser';
import introJs from "intro.js";
const { ajax, getLangCode } = platform;
const NCC_APP_URL = 'NCCAPPURL';
import { setVarsByThemeName } from 'Pub/js/theme/index';
import Ajax from 'Pub/js/ajax';
import { createTree } from "Pub/js/createTree.js";
import { MYAPPINFO } from './allApps';
import { designerColor, designerVars } from 'Pub/js/theme/designer';
import { defaultFormTitleColor } from "Pub/js/subjectDefaultData";

let step = null; //新手引导步骤

// 将url缓存到sessionStorage中
// IE由于存在sessionStorage中会导致打开7个页签以上浏览器crash
// Safari由于复制标签页会丢失sessionStorage
// 所以做个兼容把url存在localStorage中
export const cacheURL = {
    setURL: function (urlKey, url) {
        const toLocal = ['IE', 'Safari'].includes(Browser());
        let appUrl = toLocal ? getStore(NCC_APP_URL) || {} : sessionStorageUtil.getItem(NCC_APP_URL) || {};
        appUrl[urlKey] = url;
        if (toLocal) {
            try {
                setStore(NCC_APP_URL, appUrl);
            } catch (e) {
                Object.keys(localStorage).forEach(item => {
                    if (item.includes('appTempletStorage_')) {
                        delete localStorage[item];
                    }
                });
                setStore(NCC_APP_URL, appUrl);
            }
        } else {
            sessionStorageUtil.setItem(NCC_APP_URL, appUrl);
        }
    },
    getURL: function () {
        let urlStore = ['IE', 'Safari'].includes(Browser()) ? getStore(NCC_APP_URL) : sessionStorageUtil.getItem(NCC_APP_URL);
        return urlStore;
    },
};

/**
 * 获取url参数
 * @param {String} query 当前 url 中传递的参数
 */
export const GetQuery = query => {
    let theRequest = {};
    if (query.indexOf("?") != -1) {
        let str = query.split("?")[1];
        if (URL_IN_SESSION && str.indexOf("page=") !== -1) {
            //url从storage里取
            const pageKey = "page=";
            let storageKey = str.slice(str.indexOf(pageKey) + pageKey.length).split('&')[0];
            // let storageKey = str.slice(str.indexOf(pageKey) + pageKey.length);
            let urlStore = cacheURL.getURL();
            str = storageKey && urlStore && urlStore[storageKey];
        }
        if (str) {
            if (str.indexOf("&") != -1) {
                if (str[0] == "&") {
                    str = str.substr(1);
                }
                let strs = str.split("&");
                for (let i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = decodeURIComponent(
                        decodeURIComponent(strs[i].split("=")[1]),
                    );
                }
            } else {
                let requestKey = str.split("=")[0];
                //解决个性化设置/桌面设置等面包屑不显示问题
                if (requestKey.includes("?n")) {
                    requestKey = "n";
                }
                theRequest[requestKey] = decodeURIComponent(
                    decodeURIComponent(str.split("=")[1]),
                );
            }
        }
    }
    return theRequest;
};
/**
 * 将对象转换成 url 参数字符串
 * @param {Object} object 参数对象
 */
export const CreateQuery = object => {
    let arg = "";
    for (const key in object) {
        if (object.hasOwnProperty(key)) {
            const element = object[key];
            arg += `&${key}=${element}`;
        }
    }
    let defParam = arg;
    let hashParam = arg.split("");
    hashParam.splice(0, 1, "#");
    hashParam = hashParam.join("");
    let searchParam = arg.split("");
    searchParam.splice(0, 1, "?");
    searchParam = searchParam.join("");
    /**
     * defParam &开头的参数
     * hashParam #开头的参数
     * searchParam ？开头的参数
     */
    return {
        defParam,
        hashParam,
        searchParam,
    };
};
/**
 * 多语校验
 * @param {String} multiLangCode
 * @param {Boolean} pages
 * @param {Object} json
 * @param {Array} replaceValues // 替换占位变量的值，适用于拼接的字符串
 */
export const langCheck = (multiLangCode, pages, json, replaceValues = []) => {
    const langJson = pages ? json : window.multiLang;
    if (langJson) {
        let langStr = langJson[multiLangCode];
        if (langStr) {
            if (replaceValues.length) {
                replaceValues.forEach((value, index) => {
                    langStr = langStr.replace('${' + (index + 1) + '}', value);
                });
            }
            return langStr;
        }
    }
    return '';
};
/**
 * 多语校验
 * @param {String} multiLangCode
 *
 *
 */
export const langZoneSetting = multiLangCode => {
    return window.multiZoneSettingLang
        ? window.multiZoneSettingLang[multiLangCode]
            ? window.multiZoneSettingLang[multiLangCode]
            : ""
        : "";
};
/**
 * 数字补位
 * @param {Number} num 需要补位的数字
 * @param {Number} n 需要补的位数
 * Pad(1,2) => // 01
 */
export const Pad = (num, n) => {
    let len = num.toString().length;
    while (len < n) {
        num = "0" + num;
        len++;
    }
    return num;
};
/**
 * 连续的ajax延迟
 * @param {Function} fn 需要延迟运行的的回调函数
 **/
let deferFnInterval;
export function DeferFn(fn) {
    deferFnInterval = new Date().getTime();
    setTimeout(() => {
        //停止输入0.5s后执行
        if (new Date().getTime() - deferFnInterval >= 500) {
            fn();
        }
    }, 500);
}
/**数组对象去重
 * @param {Object} arr 需要去重的数组对象
 * @param {String} name 对象key值名
 */
export const arrayUnique = (arr, name) => {
    var hash = {};
    return arr.reduce(function (item, next) {
        hash[next[name]] ? "" : (hash[next[name]] = true && item.push(next));
        return item;
    }, []);
};

/**js代码深拷贝
 * @param {Object} data 需要深拷贝的对象
 */
export const getType = obj => {
    //tostring会返回对应不同的标签的构造函数
    var toString = Object.prototype.toString;
    var map = {
        "[object Boolean]": "boolean",
        "[object Number]": "number",
        "[object String]": "string",
        "[object Function]": "function",
        "[object Array]": "array",
        "[object Date]": "date",
        "[object RegExp]": "regExp",
        "[object Undefined]": "undefined",
        "[object Null]": "null",
        "[object Object]": "object",
    };
    if (obj instanceof Element) {
        return "element";
    }
    return map[toString.call(obj)];
};

export const deepClone = data => {
    var type = getType(data);
    var obj;
    if (type === "array") {
        obj = [];
    } else if (type === "object") {
        obj = {};
    } else {
        //不再具有下一层次
        return data;
    }
    if (type === "array") {
        for (var i = 0, len = data.length; i < len; i++) {
            obj.push(deepClone(data[i]));
        }
    } else if (type === "object") {
        for (var key in data) {
            obj[key] = deepClone(data[key]);
        }
    }
    return obj;
};

/**
 * 获取cookie
 */
export const getCookie = c_name => {
    //键的名字
    if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(c_name + "="); //获取字符串的起点
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1; //获取值的起点
            let c_end = document.cookie.indexOf(";", c_start); //获取结尾处
            if (c_end == -1) { c_end = document.cookie.length; } //如果是最后一个，结尾就是cookie字符串的结尾
            return decodeURI(document.cookie.substring(c_start, c_end)); //截取字符串返回
        }
    }
    return "";
};

/**
 * 生成urlkey
 * @param {String} appcode AppCode
 * @param {String} pagecode PageCode
 * @param {String} menucode 菜单编码
 * @param {Boolean} unique 唯一值（加时间戳）
 */
export const generateUrlKey = ({ appcode, pagecode, menucode, unique = false } = {}) => {
    // NOTE
    // 根据当前标准流程规则，URL Key这个唯一值有appcode与pagecode来确认。作为打开新标签也的pagename参数。
    // 淡入如果未来有如下需求时，需要再增加确认urlkey的参数规则：
    // 当开发想要在一个小应用下用新窗口打开同样的页面只是url search参数不同时就需要增加生成urlkey的参数规则
    let ts = new Date();
    let urlkey = (appcode && pagecode) ? `${appcode}-${pagecode}${menucode ? `-${menucode}` : ''}` : `${ts.getTime()}`;
    let r = Math.round(getRandomValue() * 23 + 100).toString();
    if (unique === true) {
        urlkey = `${urlkey}-${ts.getTime()}${r}`;
    }
    // return window.btoa(urlkey);
    return encodeURIComponent(urlkey);
};

//将url放到session中
export function setUrlInSession(urlKey, url) {
    cacheURL.setURL(urlKey, url);
}

/**
 * 防抖
 * @param {Function} fn 执行函数
 * @param {Number} wait 等待时间
 */
export function debounce(fn, wait) {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        if (timer !== null) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            fn.apply(context, args);
        }, wait);
    };
}
/**
 * 节流
 * @param {Function} fn 执行函数
 * @param {Number} delay 节流时间
 */
export function throttle(fn, delay = 500) {
    let prevTimer = Date.now();
    return function () {
        let context = this;
        let args = arguments;
        let now = Date.now();
        if (now - prevTimer >= delay) {
            fn.apply(context, args);
            prevTimer = Date.now();
        }
    };
}

//生成uuid
export const uuid = (len, radix) => {
    let chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
    let result = [],
        i;
    radix = radix || chars.length;

    if (len) {
        // Compact form
        for (i = 0; i < len; i++) { result[i] = chars[0 | (getRandomValue() * radix)]; }
    } else {
        // rfc4122, version 4 form
        let r;

        // rfc4122 requires these characters
        result[8] = result[13] = result[18] = result[23] = "-";
        result[14] = "4";

        // Fill in random data. At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!result[i]) {
                r = 0 | (getRandomValue() * 16);
                result[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
            }
        }
    }

    return result.join("").toLowerCase();
};

/**
 * 传入flag 校验当前节点的操作是否是正式环境,以及业务自定义的提示信息，如果业务传来的msg为空则使用默认的，不空就是用传来的提示语
 * riasm.ctms.qrycurrentappcanused
 * 返回true继续进行调用方自己的点击事件逻辑，返回false终止调用方自己逻辑即可
 * @param {*} flag
 */
export function ctmsCheckClickCanUsed(flag, msg) {
    return new Promise((resolve, reject) => {
        ajax({
            url: '/nccloud/riasm/ctmsconfig/qrycurrentappcanused.do',
            data: flag,
            success: ({ data }) => {
                if (data.result == false) {
                    if (msg !== undefined) {
                        Notice({ status: 'warning', msg: msg }); //自定义提示
                    } else {
                        Notice({ status: 'warning', msg: data.msg }); //默认提示
                    }
                }
                resolve(data.result);
            },
        });
    });
}

//动态加载script
export function loadScript(src) {
    if (!src) { return; }
    let scripts = Array.from(document.getElementsByTagName('script'));
    let target = scripts.find(item => item.src.includes(src));
    return new Promise((resolve, reject) => {
        // 已经加载过script标签
        if (target) {
            resolve(target);
        } else {
            let script = document.createElement("script");
            script.src = src;
            script.type = "text/javascript";
            document.body.appendChild(script);
            script.onload = () => resolve(script);
        }
    });
}

//动态加载style
export function loadStyle(url) {
    let head = document.getElementsByTagName("head")[0];
    let link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = url;
    head.appendChild(link);
}

//创建加密安全的随机数，用来替代Math.random()
export function getRandomValue() {
    const crypto = window.crypto || window.msCrypto;
    return crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296;
}

//获取自动化环境开关 1表示是自动化环境
export const getAutoFlag = () => getStore('_ncc_automated_') == '1';

//根据用户名称截取头像名
export const getAvatarName = userName => {
    if (!userName) { return ''; }
    const arr = userName && userName.split(' ');
    const pictureName = arr.length > 1 ? arr[0].substring(0, 1) + arr[1].substring(0, 1) : arr[0].substring(arr[0].length - 2, arr[0].length);
    return pictureName;
};

//删除模板缓存 removeCount: 删除的模板数量
export function removeTempletCache(removeCount) {
    const allTempletCache = Object.keys(localStorage).filter(item => item.indexOf("appTempletStorage_") != -1);
    if (allTempletCache && removeCount !== undefined) {
        const removedTemplet = allTempletCache.filter((item, i) => i < removeCount);
        removedTemplet.forEach(item => {
            localStorage.removeItem(item);
        });
    }
    return allTempletCache.length;
}

//兼容卡片间隔历史数据format
export const cardIntervalFormat = value => {
    //2111版历史数据
    const distanceMap = {
        tight: '8', //紧凑
        moderate: '16', //适中
        relax: '24', //宽松
    };
    return distanceMap[value] || value;
};

// 新手引导提示
export const startIntro = (callback, is_cloud_register, deployType) => {
    PubSub.publish('introJs', true);
    // intro配置项
    const introOptions = {
        prevLabel: langCheck("0000PUB-000294"), //上一步
        nextLabel: langCheck("0000PUB-000295"), //下一步
        skipLabel: langCheck("0000PUB-000296"), //跳过指引
        doneLabel: langCheck("0000PUB-000297"), // 完成
        exitOnEsc: true, //ESC关闭introOptions
        exitOnOverlayClick: true, //点击叠加层时退出介绍
        keyboardNavigation: true, //键盘导航
        showStepNumbers: false, //显示红色圆圈中的步骤编号
        hidePrev: true, //在第一步中隐藏上一个按钮
        hideNext: true, //在最后一步隐藏下一个按钮
        hideSkipLabel: false,
        tooltipPosition: "auto", //默认工具提示位置
        // highlightClass: 'novice-guide-intro' //默认高亮样式
    };
    const Intro = introJs()
        .setOptions(introOptions)
        .onafterchange(function (e) {
            //点击结束按钮后，加类名
            step = parseInt(e.getAttribute('data-step'));
            const introjsHelperLayer = document.getElementsByClassName('introjs-helperLayer')[0];
            // const allBench = document.querySelector('.nc-workbench-all-bench');
            // console.log(allBench.offsetWidth)
            introjsHelperLayer.className = `introjs-helperLayer introjs-${step}`;
        })
        .onexit(() => {
            window.handleWorkbenchIntro = null;
            if (step) {
                step === 7 && callback && callback();
                PubSub.publish('introJs', false);
                if (is_cloud_register && deployType === 'cloud') {
                    // 云注册环境 deployType 为cloud  帮助中心 
                    step === 7 && callback && callback();
                } else {
                    step === 6 && callback && callback();
                }
            }
        })
        .start();
    window.handleWorkbenchIntro = type => {
        if (type === 'close') {
            Intro.exit();
        }
    };
};
//获取父级window
export const getWindow = (win = window) => {
    if (win.parent !== win) {
        //找到yonbip那层iframe
        if (window.parent.document.querySelector('#forwardFrame')) {
            return win.parent;
        }
    }
    return win;
};

//获取默认注销跳转地址 yonbip域名跳转到yonbip
export const DEFAULT_LOGOUT_URL = getWindow() !== window ? "/yonbip/" : "/nccloud/";

export const getOriginPath = () => {
    const pathName = window.top.location.pathname;
    return pathName.split('resources').shift();
};

//JSON.parse报错时返回原始数据
export const JSONparse = data => {
    try {
        return JSON.parse(data);
    } catch (error) {
        return data;
    }
};

//获取面包屑数据
// includeCode 是否包含各级的编码
export const getBreadCrumbInfo = (data, includeCode = false) => {
    let result = {};
    const { fifthmenu } = data;
    let breadCrumbKeys = ['field', 'module', 'menuclass', 'menu']; // 领域/模块/应用分组/应用
    if (fifthmenu) { // 个别领域有五级菜单 需要区分四级菜单和五级菜单
        breadCrumbKeys = [ ...breadCrumbKeys, 'fifthmenu' ]; // 领域/子领域/模块/应用分组/应用
    }
    const bcList = breadCrumbKeys.map(item => data[item]);
    bcList.forEach((item, i, arr) => {
        const key = i === arr.length - 1 ? 'n' : `b${i + 1}`; //末级是n，其他层级为b1/b2/b3/b4
        result[key] = item;
        if (includeCode) {
            const codeKey = `${breadCrumbKeys[i]}code`;
            result[codeKey] = data[codeKey];
        }
    });
    return result;
};

const ThemeTypes = ['default', 'default1', 'red', 'green', 'black', 'blue', 'yellow', 'mixin'];
/**
 * 
 * @param {*} themeType  主题名称
 * @param {*} mixinColor  自定义主题时颜色
 * // 切换主题实时生效 更换 plantform css 包括iframe  
 */
export const setThemeAndIframe = (themeType, mixinColor) => {
    setWorkbenchTheme(themeType, mixinColor);
    setIframesTheme(themeType, mixinColor);
};

// 设置iframe主题
const setIframesTheme = (themeType, mixinColor) => {
    themeType = convertThemeType(themeType);
    // 业务设置
    setIframeTheme('customizeiframe', { themeType, mixinColor });
};

// 转换themeType
const convertThemeType = themeType => {
    return themeType === 'white' ? 'default' : themeType;
};

// 设置工作桌面主题
export const setWorkbenchTheme = (themeType, mixinColor) => {
    let customThemeVars = {};
    // const hashQuerys = GetQuery(location.hash);
    // const { c } = hashQuerys;
    // if (c === '102202SANDBOX') { // 设计器
    //     themeType = 'mixin';
    //     mixinColor = designerColor;
    //     customThemeVars = designerVars;
    //     setBodyClass({
    //         themeType: 'mixin'
    //     });
    // } else {
    themeType = convertThemeType(themeType);
    // }
    window.setTheme({ themeType, mixinColor, ThemeTypes, baseName: 'nc-lightapp-front' });
    // 设置工作桌面的var主题 mixinColor 自定义主要要用
    setVarsByThemeName(themeType, mixinColor, null, customThemeVars);
};

// 设置iframe内部主题
// iframeId: id or element
export const setIframeTheme = (iframeId, { themeType, mixinColor }) => {
    themeType = convertThemeType(themeType);
    let ifr = iframeId;
    if (typeof iframeId === 'string') {
        ifr = document.getElementById(iframeId);
    }
    if (ifr && ifr.contentWindow) {
        if (ifr.contentWindow.updateWorkbenchTheme) { // 工作台设计器
            const currentTheme = getStore('nccTheme');
            ifr.contentWindow.updateWorkbenchTheme(currentTheme);
        } else {
            ifr.contentWindow.setTheme && ifr.contentWindow.setTheme({ themeType, ThemeTypes, mixinColor, baseName: 'nc-lightapp-front' }); // frames 主题立即生效
        }
    }
};

// 设置body类名
export const setBodyClass = ({ themeType, rootElement, dealWithPlatform = false }) => {
    if (!rootElement) {
        rootElement = document.getElementById('workbench');
    }
    const bodyClassList = rootElement.classList;

    let themeKeys = ['workbench-'] // 工作桌面主题类名
    if (dealWithPlatform) { // 处理platform的主题类名
        themeKeys.push('nc-lightapp-front-');
    }
    themeKeys.forEach(themeKey => {
        const currentThemeType = ThemeTypes.find(type => bodyClassList.contains(`${themeKey}${type}`));
        if (currentThemeType) {
            bodyClassList.remove(`${themeKey}${currentThemeType}`);
        }
        themeType && bodyClassList.add(`${themeKey}${themeType}`);
    })

    bodyClassList.add('workbench-theme');
};

// 不处理暗黑的
export const isNotDealDark = search => {
    let { c, n, p, pagecode } = search;
    /**
     * 审批流定义-集团、
     * 审批流定义-业务单元、
     * 业务流定义、
     * 工作流定义-集团、
     * 工作流定义-业务单元、
     * 条形码标签设计、
     * 分析报表设计-集团、
     * 分析报表设计-组织
     * 图表管理、
     * 故事板管理、
     * 查看故事板、
     * 条形码标签设计-库存组织
     * 巡检监控
     * 工单看板
     * 模板编辑器
     * 消息模板
     * 应用导航设计
     * 应用导航预览
     * 资产分布图
     */
    const appCode_Map = [
        "101650",
        "101651",
        "101652",
        "101653",
        "101654",
        "401700402",
        "20550101",
        "20550102",
        "1888020000",
        "1888020004",
        "1888040000",
        "401700404",
        "455001516A",
        "456001544A",
        "10182TM",
        "10180402",
        "10180403",
        "102201APP",
        "10164503",
        "451012504A",
        "160312004A", // 结账分析-集团
        "160312008A", // 结账分析-业务单元
        "160312012A", // 结账分析-分享中心
        "160312016A", // 结账分析-个人
        "160301504A", // 结账监控台-集团
        "160301508A", // 结账监控台-共享中心
        "160104010A", // 任务监控台
        "160301004A", // 主管结账工作台
        "160301008A", // 我的结账工作台
        "160103010A", // 任务工作台
        "390300402", // 企业运营仪表板-集团
        "390300404", // 企业运营仪表板-法人公司
        "390300406", // 销售业务仪表板-集团
        "390300408", // 销售业务仪表板-法人公司
        "390300410", // 采购业务仪表板-集团
        "390300412", // 采购业务仪表板-法人公司
        "451001312A", // 资产画像
        "4802010005", // 项目看板-项目
        "4820085005", // 付款合同看板-项目
        "4825085005", // 收款合同看板-项目
        "456525004A", // 特种设备总览
        "456525008A", // 计量器具总览
        "451012508A", // 资产台账
        "201204504A", // 卡片台账
        "456201004A", // 设备劣化趋势
        "456201008A", // 设备寿命分析
        "453402520A", // 租赁业务分析-到访客户
        "453402524A", // 租赁业务分析-签约客户
        "453402528A", // 租赁业务分析-楼宇
        "903000402", // 企业运营仪表板-集团
        "903000404", // 企业运营仪表板-法人公司
        "903000406", // 销售业务仪表板-集团
        "903000408", // 销售业务仪表板-法人公司
        "903000410", // 采购业务仪表板-集团
        "903000412", // 采购业务仪表板-法人公司
        "201205016A", // 资产经营效益
        "201205012A", // 资产发展潜力
        "182003004A", // 财务综合分析（企业报表）
        "183006504A", // 财务综合分析（合并报表）
        "1888020001", // 图表设计
    ];
    // 后续可以考虑页面级别的控制，更细化，同一个应用下多个页面可以独立
    if (
        (c && appCode_Map.includes(c)) ||
        (c === "10180TM" && (p === "10182TM_PAGE" || pagecode === "10182TM_PAGE")) ||
        (c === "10181TM" && (p === "10182TM_PAGE" || pagecode === "10182TM_PAGE")) ||
        (c === "10300302" && (p === "10182TM_PAGE" || pagecode === "10182TM_PAGE")) || // 自由报表-全部 打开打印模板设计器 不适配暗黑
        (c === "10220OUTPUT" && (p === "10221OUTPUT_PAGE" || pagecode === "10221OUTPUT_PAGE"))
    ) {
        return true;
    }

    return false;
};

// im消息登录接口 
export const imLogin = () => {
    return new Promise((resove, reject) => {
        const imData = getStore('NCC_IMData');
        if (imData) {
            resove(imData);
            return;
        }
        Ajax({
            url: '/nccloud/platform/login/loginyhtanddiwork.do',
            info: {
                name: langCheck('0000PUB-000111'), /* 国际化处理： im消息*/
                appcode: "10228888",
                action: langCheck('0000PUB-000112'), /* 国际化处理： im登录*/
            },
            success: function ({ data }) {
                setStore('NCC_IMData', data.data); //缓存起来，减少请求
                resove(data.data);
            },
        });
    });
};

// 获取自定义主题
export const getCustomTheme = params => {
    return new Promise(resolve => {
        Ajax({
            url: '/nccloud/platform/appregister/querycustomtheme.do',
            data: params || {},
            success: function ({ data }) {
                if (data.success) {
                    data.data.forEach(theme => {
                        theme.editable = params && params.styletype === theme.styletype;
                    });
                    resolve(data.data);
                } else {
                    resolve([]);
                }
            },
            error: () => {
                resolve([]);
            }
        });
    });
};

export const getMenuitemsTree = params => {
    return new Promise(resolve => {
        Ajax({
            url: '/nccloud/platform/appregister/querymenuitemstreesynch.do',
            data: params || {},
            loading: true,
            success: function ({ data }) {
                if (data.success) {
                    data.data.forEach(item => {
                        item.refpk = item.treePk;
                        if (item.treeParentId) {
                            item.pid = item.treeParentId;
                        }
                        item.refname = `${item.code} ${item.name}`;
                    });
                    const treeData = createTree(data.data, 'treePk', 'treeParentId');
                    resolve(treeData);
                }
            },
        });
    });
};

// 生成部件主键
export const getPartsPk = () => {
    return new Promise(resolve => {
        Ajax({
            url: '/nccloud/platform/appregister/getpartspk.do',
            success: function ({ data }) {
                if (data.success) {
                    resolve(data.data);
                }
            },
        });
    });
};

// 获取工作台集合
// forcePull: 强制拉取最新数据
export const getWorkbenchData = (params = {}, forcePull = false) => {
    return new Promise(resolve => {
        const resolveFunc = resData => {
            if (location.hash.includes('is_group=true')) { // 集团管理员应用管理 -> 工作台设置
                // 确认有且仅有一个工作台，直接遍历改掉名字
                resData.forEach(item => item.name = langCheck('0000PUB-000599' /* 集团管理员工作台 */))
            }
            resolve(resData);
        }
        const emptyParams = Object.keys(params).length === 0;
        if (emptyParams && !forcePull) {
            const workbenchNavsCache = getStore('workbenchNavs');
            if (workbenchNavsCache) {
                resolveFunc(workbenchNavsCache);
                return;
            }
        }

        Ajax({
            url: '/nccloud/platform/appregister/queryworkbenchnavigator.do',
            type: 'post',
            data: params,
            success: res => {
                let { success, data } = res.data;
                if (success) {
                    if (!data.length) { return; }

                    // 排序
                    data.sort((a, b) => { return (Number(a.position) - Number(b.position)); });

                    // 没有默认的处理一下
                    if (!data.some(item => item.isdefault)) {
                        const fieldPresetArr = data.filter(item => item.treetype != 1);
                        if (fieldPresetArr.length === 1) { // 用户仅关联一个角色工作台的（非集团默认），则默认展示这个
                            fieldPresetArr[0].isdefault = true;
                        } else {
                            const groupDefault = data.find(item => item.treetype == 1);
                            if (groupDefault) { // 集团默认
                                groupDefault.isdefault = true;
                            } else {
                                data[0].isdefault = true;
                            }
                        }
                    }

                    // 没有固定的让前三个固定
                    if (!data.some(item => item.isfixed)) {
                        for (let i = 0; i < data.length; i++) {
                            if (i < 3) {
                                data[i].isfixed = true;
                            } else {
                                break;
                            }
                        }
                    }

                    // 设置激活的工作台（优先取缓存，其次设置默认的）
                    let activedBench;
                    const lastActived = getStore('activeWorkbench');
                    if (lastActived) {
                        activedBench = data.find(item => item.workbenchid === lastActived);
                    }
                    if (!activedBench) {
                        activedBench = data.find(item => item.isdefault); // 默认的选中
                    }
                    activedBench && (activedBench.active = true);

                    resolveFunc(data);

                    if (emptyParams) { // 缓存起来
                        setStore('workbenchNavs', data);
                    }
                }
            },
        });
    });
};

// 获取屏幕缩放比例
export const getRatio = () => {
    let ratio = 0;
    const win = getWindow();
    const screen = win.screen;
    const ua = navigator.userAgent.toLowerCase();

    if (win.devicePixelRatio !== undefined) {
        ratio = win.devicePixelRatio;
    }
    else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
            ratio = screen.deviceXDPI / screen.logicalXDPI;
        }

    }
    else if (win.outerWidth !== undefined && win.innerWidth !== undefined) {
        ratio = win.outerWidth / win.innerWidth;
    }

    if (ratio) {
        ratio = Math.round(ratio * 100);
    }
    return ratio;
};

// 获取localstorage里面的 myAppInfo
export const getMyAppInfoValue = () => {
    const moduleId = getStore(MYAPPINFO) && getStore(MYAPPINFO).value;
    return moduleId || '';
};

// 请求最近访问接口
export const queryRecentVisit = () => {
    return new Promise(resolve => {
        Ajax({
            url: "/nccloud/platform/appregister/queryrecentvisit.do",
            data: {},
            info: {
                name: langCheck("0000PUB-000276") /* 国际化处理： 最近访问*/,
                action: langCheck("0000PUB-000313"), /* 国际化处理： 查询最近访问*/
            },
            success: ({ data }) => {
                if (data.success && data.data) {
                    const result = data.data;
                    resolve(result.splice(0, 20));
                }
            },
            error: error => {
                console.log(error);
            },
        });
    });

};

// 清空最近访问
export const deleteRecentVisit = () => {
    return new Promise(resolve => {
        Ajax({
            url: "/nccloud/platform/appregister/deleterecentvisit.do",
            data: {},
            info: {
                name: langCheck("0000PUB-000276") /* 国际化处理： 最近访问*/,
                action: langCheck("0000PUB-000314"), /* 国际化处理： 清空最近访问*/
            },
            success: ({ data }) => {
                if (data.success) {
                    resolve(data.success);
                }
            },
            error: error => {
                console.log(error);
            },
        });
    });
};

// 处理外部链接url
export const handleExternalLinkUrl = iptUrl => {
    if (!(iptUrl.startsWith('http://') || iptUrl.startsWith('https://'))) {
        return iptUrl = `http://${iptUrl}`;
    }
    return iptUrl;
};
// 判断系统类型
export const OSnow = () => {
    let code = '';
    var agent = navigator.userAgent.toLowerCase();
    var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
    if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
        code = 'win32';
    }
    if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
        code = 'win64';
    }
    if (isMac) {
        code = 'mac';
    }
    return code;
};

// iframe 设置缩放
export const setIframeZoom = (zoom, iframeDocument) => {
    return; // 去掉缩放功能
    if (!zoom) {
        zoom = getStore('zoom');
        if (!zoom) { return; }
    }
    let zoomValue = zoom;
    if (zoom == 0.7) {
        zoomValue = 0.666;
    } else if (zoom === 0.6) {
        zoomValue = 0.57;
    }
    const handleIfrZoom = curDocument => {
        curDocument.body.style.zoom = zoomValue;
        const iframes = curDocument.querySelectorAll('iframe');
        iframes.forEach(item => {
            handleIfrZoom(item.contentDocument);
        });
    };
    handleIfrZoom(iframeDocument || document);
    setStore('zoom', zoom);
};

// 是否显示分辨率提示
export const isShowResolutionprompt = () => {
    if (getStore('countDownCloseResolution')) { return false; } // 倒计时关闭了
    if (!getStore('zoomValue')) {
        setStore('zoomValue', { show1: true, show2: false, show3: false });
    }
    let flag = false;
    // const arr = [125, 150, 175]; mac 不需要显示
    if (((Browser() === 'Chrome' || Browser() === 'Edge' || Browser() === 'Firefox') && getStore('zoomValue').show1) && OSnow() !== 'mac') {
        // show3 只要判断过一次 show3就为true
        if (!getStore('zoomValue').show3) {
            if (getRatio() > 100) {
                // 只判断一次
                flag = true;
                setStore('zoomValue', { show1: true, show2: true, show3: true });
            } else {
                setStore('zoomValue', { show1: true, show2: false, show3: true });
            }
        }
        // show2 第一次设置为true时  就需要一直是true
        if (getStore('zoomValue').show2) {
            flag = true;
        }
    }
    return flag;
};

// 获取显示分辨率的值
export const getResolutionNumber = () => {
    let number = 100;
    if (Browser() === 'Chrome' || Browser() === 'Edge') {
        if (getRatio() === 125) {
            number = 75;
        } else if (getRatio() === 150) {
            number = 67;
        } else if (getRatio() === 175) {
            number = 50;
        }
    }
    if (Browser() === 'Firefox') {
        if (getRatio() === 125) {
            number = 80;
        } else if (getRatio() === 150) {
            number = 67;
        } else if (getRatio() === 175) {
            number = 50;
        }
    }
    return number;
};

/**
 * 获取拼接多语
 */
export function getLang(jsonStr, values) {
    if (values && jsonStr) {
        for (const key in values) {
            jsonStr = jsonStr.replace(`{${key}}`, values[key]);
        }
    }
    return jsonStr;
}

// 更新
export function updateUrlInSesion(search, data) {
    // 更新一下缓存里的
    const pageKey = "page=";
    if (search && search.includes(pageKey)) {
        const searchStr = search.split('?')[1];
        const storeKey = searchStr.slice(searchStr.indexOf(pageKey) + pageKey.length).split('&')[0];
        const urlStore = cacheURL.getURL();
        const resultArr = [];
        const dataKeys = Object.keys(data);
        if (urlStore) {
            const urlStr = urlStore[storeKey];
            if (urlStr) {
                const urlArr = urlStr.split('&').map(item => item.split('='));
                urlArr.forEach(item => {
                    let [key, value] = item;
                    if (item.length === 1) { // 只有key没有值
                        resultArr.push(key);
                    } else {
                        if (data[key]) {
                            value = encodeURIComponent(encodeURIComponent(data[key]));
                            _.remove(dataKeys, k => k === key);
                        }
                        if (key === 'lang') {
                            value = getLangCode();
                        }
                        resultArr.push(`${key}=${value}`);
                    }
                });
                if (dataKeys.length) { // 新字段，缓存中没有的
                    dataKeys.forEach(key => {
                        data[key] && resultArr.push(`${key}=${encodeURIComponent(encodeURIComponent(data[key]))}`);
                    });
                }
            }
        }
        resultArr.length && setUrlInSession(storeKey, resultArr.join('&'));
    }
}

const getNccFont = val => {
    const numToStr = num => {
        if (12 <= num && num <= 13) { return 'small'; }
        if (14 <= num && num <= 15) { return 'medium'; }
        if (16 <= num && num <= 17) { return 'large'; }
    };
    const strToNum = str => {
        return {
            small: '12',
            medium: '15',
            large: '17',
        }[str];
    };
    const fontNumber = Number(val);
    if (isNaN(fontNumber)) { return { fontSize: val, fontValue: strToNum(val) }; }
    return { fontSize: numToStr(fontNumber), fontValue: String(val) };
};
const BodyFontClassMap = {
    small: 'bodySmall',
    medium: 'bodyMedium',
    large: 'bodyLarge',
};
export const setNccFontSize = (fz = 'small', rootElement, isStorage = true) => {
    if (!rootElement) {
        rootElement = document.getElementById('workbench');
    }

    const nccFont = getNccFont(fz);
    const { fontSize, fontValue } = nccFont;

    // 处理字号类名
    let fontClass = BodyFontClassMap[fontSize];
    if (fontValue === '12') {
        fontClass = ''; // 默认的保持之前一样，不设置类名
    }
    const bodyClassList = rootElement.classList;
    const fontClassList = Object.entries(BodyFontClassMap).map(([key, value]) => value).filter(classname => classname);
    const currentFontClass = fontClassList.find(font => bodyClassList.contains(font));
    if (currentFontClass) {
        bodyClassList.remove(currentFontClass);
    }
    fontClass && bodyClassList.add(fontClass);
    
    // 移除platform设置的
    const platformGlobalFontClass = [...bodyClassList].find(item => item.startsWith('globel-fontsize'));
    platformGlobalFontClass && bodyClassList.remove(platformGlobalFontClass);

    // 设置css变量
    rootElement.style.setProperty('--ncc-font-size', `${fontValue}px`);

    // 存储
    if (isStorage) {
        window.nccFontSize = fontSize;
        window.nccFontValue = fontValue;
        setStore('nccFontSize', fontSize);
        setStore('nccFontValue', fontValue);
    }
    return nccFont;
};

export const setNccFormStyle = (formstyle = {}) => {
    const newFormStyle = _.merge({
        formupdownstyle: false,
        formunderlinestyle: false,
        formtitlecolor: defaultFormTitleColor,
    }, formstyle);
    delete newFormStyle.formtitlecolor; // 这个功能去除了，字段移除
    window.nccForm = newFormStyle;
    setStore('nccForm', newFormStyle);
};

export const setNccTableStyle = (tableStyle = {}) => {
    const nccTable = _.merge({
        tableType: "compact",
        crossCheck: false,
        cuttingCheck: true,
        rowcheckedButton: 'rowCheckFixed',
        inputdataformat: false,
        tablehdbgcolor: 'light',
        selectedrowcolor: 'light',
    }, tableStyle);
    window.nccTable = nccTable;
    setStore('nccTable', nccTable);
}

export const queryLanguage = params => {
    return new Promise(resolve => {
        Ajax({
            url: '/nccloud/platform/appregister/querylanguagevos.do',
            data: params || {},
            success: ({ data: { data } }) => {
                if (data && data.length > 0) {
                    /**
                     * 前端组合成多语文本可以支持的options
                     */
                    let multiOptions = data.map((item, index) => {
                        let itemIndex = ++index;
                        let multiItem = {
                            index: "",
                            languageType: "zh",
                            languageCode: "simpchn",
                        };
                        multiItem.index = itemIndex > 1 ? multiItem.index + itemIndex : "";
                        multiItem.languageType = item.locallang;
                        multiItem.languageCode = item.langcode;
                        multiItem.languageMain = item.langseq == "1" ? true : false;
                        return multiItem;
                    });
                    resolve(multiOptions);
                }
            },
        });
    });
};

export const getMultiLangDisplayText = (data, propertyKey, multiOptions) => {
    let local = getLangCode('langCode');
    let localText = '';
    let mainText = '';
    let itemKey = propertyKey;
    let ret;
    if (!multiOptions) {
        return _.get(data, itemKey, '');
    }
    multiOptions.forEach(opt => {
        let { languageMain, index, languageCode } = opt;
        itemKey = `${propertyKey}${index}`;
        if (languageCode === local) {
            localText = _.get(data, itemKey);
        }
        if (languageMain === true) {
            mainText = _.get(data, itemKey);
        }
    });
    ret = localText && localText.length > 0 ? localText : mainText;
    return ret;
};

// 获取水印设置接口
export const getWatermarkSettings = params => {
    return new Promise(resolve => {
        Ajax({
            url: '/nccloud/workbench/corporatestyle/querywatermark.do',
            data: params || {},
            success: function ({ data }) {
                if (data.success) {
                    resolve(data.data || {});
                } else {
                    resolve({});
                }
            },
            error: () => {
                resolve({});
            }
        });
    });
};

// 设置水印设置接口
export const setWatermarkSettings = params => {
    return new Promise(resolve => {
        Ajax({
            url: '/nccloud/platform/appregister/setwatermarksettings.do',
            data: params || {},
            success: function ({ data }) {
                if (data.success) {
                    resolve(data.data);
                }
            },
        });
    });
};

// params a=1&b=2
export const urlAddParams = (url, params) => {
    let urlHasParams;
    // 检测是否已经存在参数
    if (/#/.test(url)) { // hash之后的才是真正的参数
        // index.html?t=123#/list?a=1
        urlHasParams = /#\/?.*\?/.test(url);
    } else {
        // index.html?a=1
        urlHasParams = /\?/.test(url);
    }
    return `${url}${urlHasParams ? '&' : '?'}${params}`;
}
// result beforeunload返回值
export const checkWindowClosable = (result) => {
    return !(result !== undefined && result !== null && result !== '');
}
// 设置内部页签变量
export const setInsideTab = (value = 'inside') => { setStore("INSIDE_TAB", value === 'inside') }
// 是否内部页签模式
export const isInsideTab = () => {
    if (isNestedWorkbench()) {
        // 内嵌在工作桌面下的工作桌面，非内部页签
        // 已目前的设计，内部页签的数据等都是单一维度的，仅支持最外层是内部页签，多层嵌套会出问题
        // 例：快速发起弹窗如果是内部页签，那么联查就会在弹窗内打开节点，此时刷新浏览器，内外有两套内部页签数据，都往storage的同一个key存，这就有问题
        return false;
    }
    return getStore("INSIDE_TAB");
};
// 是否是嵌套的工作桌面
export const isNestedWorkbench = () => {
    // 场景：快速发起弹窗模式打开节点
    return window !== getTopWorkbenchWin();
}

// 获取顶层工作桌面
export const getTopWorkbenchWin = (win = window, topWin = window) => {
    if (win === win.parent || win.document.querySelector('#forwardFrame')) {
        return topWin;
    } else {
        return getTopWorkbenchWin(win.parent, win.parent.workbenchWindow || topWin);
    }
}

// 是否有效的字符串
export const isValidString = val => val && val !== "null" && val !== 'undefined';

// 查找两个对象之间的差异
export function diffBetweenObjects(object, base) {
    function changes(object, base) {
        return _.transform(object, function(result, value, key) {
            if (!_.isEqual(value, base[key])) {
                result[key] = _.isArray(value) ? _.difference(value, base[key]) : ((_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value);
            }
        });
    }
    return changes(object, base);
}

// 更新维度信息
export function updateDimenMap(appcode, dimenMap) {
    if (!appcode || !dimenMap) { return; }
    
    let newDimenMap = {};
    for (let k in dimenMap) {
        newDimenMap[`${appcode}-${k}`] = dimenMap[k]; // 转换，加上appcode
    }
    const dimenMapCache = getStore('dimenMap') || {};
    setStore('dimenMap', { ...dimenMapCache, ...newDimenMap });
}